<template>
  <div class="hello">

    <div v-if="success">
      <h1 class="is-size-1 has-text-centered">{{ $t('This form has been sent successfully.') }} <i>¡Gracias! </i>
      </h1>
    </div>

    <form v-else @submit.prevent="submit" novalidate>
      <div class="field">
        <label class="label">{{ $t('First name') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="firstName" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.firstName.$error">{{ $t('nec') }}</div>
      </div>
      <div class="field">
        <label class="label">{{ $t('Surname') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="surName" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.surName.$error">{{ $t('nec') }}</div>
      </div>
      <div class="field">
        <label class="label">{{ $t('Bodega') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="bodega" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.bodega.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('City') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="city" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.city.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Title of profession') }} <span class="required">*</span></label>
        <div class="control">
          <input v-model="professionTitle" type="text" class="input">
        </div>
        <div class="has-text-error-message" v-if="v$.professionTitle.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Handle for twitter') }}</label>
        <div class="control">
          <input v-model="twitter" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.twitter.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Instagram url') }}</label>
        <div class="control">
          <input v-model="instagram" type="url" class="input" placeholder="https://">
          <div class="has-text-error-message" v-if="v$.instagram.$error">{{ $t('url') }}</div>
        </div>
      </div>

      <label class="label">{{ $t('Upload your photo') }}</label>
      <div class="uploader uploader1">
        <file-upload v-show="files.length == 0"
                     input-id="file1"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/png,image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file1"
                     v-model="files"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader1'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB.') }}
              <br>
              {{ $t('Allowed file types: gif jpg jpeg.') }}
            </div>
          </div>

        </file-upload>
        <div v-if="files.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files.length ? files[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>


      <label class="label">{{ $t('Upload bodega & wine photos') }} </label>
      <div class="uploader uploader2">
        <file-upload v-show="files2.length == 0"
                     input-id="file2"
                     class="has-text-centered "
                     extensions="jpg,jpeg,png"
                     accept="image/png,image/jpeg"
                     post-action="/api/upload-image/"
                     ref="file2"
                     v-model="files2"
                     :headers="{'X-CSRFTOKEN': csrf}"
                     :drop="'.uploader2'"
                     :size="1024 * 1024 *4"
                     @input-filter="inputFilter"
                     @input-file="inputFile2"
        >
          <div>
            <div class="is-size-6 has-text-weight-bold">{{ $t('Files must be less than 2 MB.') }}
              <br>
              {{ $t('Allowed file types: gif jpg jpeg.') }}
            </div>
          </div>

        </file-upload>
        <div v-if="files2.length > 0">
          <div class="columns is-gapless">
            <div class="column is-4">
              <img
                  :src="files2.length ? files2[0].thumb : 'https://www.gravatar.com/avatar/default?s=200&r=pg&d=mm'"
                  class="upload-photo"/>
            </div>
            <div class="column">
              <div>
                <p class="pb-5">{{ files2[0].name }}</p>

                <button
                    style="background: #D37700 !important; font-size: 14px; padding: 10px 10px;border: none;margin-top:8px"
                    class="button is-uppercase has-text-weight-bold has-text-white" @click="files2=[]"
                    type="button">X
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="field">
        <label class="label">{{ $t('How long have you been working in sherry and for how long have you been working at this bodega?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="howLong" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.howLong.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('What made you want to become a sherry winemaker?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="whatMade" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.whatMade.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('What wine are you proudest of and why?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="proudest" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.proudest.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('What is your favourite sherry and why?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="favouriteSherry" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.favouriteSherry.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('What is your favorite sherry wine pairing?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="favouriteWine" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.favouriteWine.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('Sherry is so unique to other wines -- what sherry fact do you find most interesting?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="mostInteresting" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.mostInteresting.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('What plans for innovation and development do you have and where do you see the future for sherry?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="plans" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.plans.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <label class="label">{{ $t('What are your earliest memories of sherry wines?') }} <span class="required">*</span></label>
        <div class="control">
          <textarea v-model="memories" class="textarea"></textarea>
        </div>
        <div class="has-text-error-message" v-if="v$.memories.$error">{{ $t('nec') }}</div>
      </div>

      <div class="field">
        <input v-model="termsAndConditions" class="is-checkradio" id="termsAndConditionsCheckbox" type="checkbox" name="termsAndConditionsCheckbox"
               checked="checked">
                        <label for="termsAndConditionsCheckbox">{{ $t('I accept the conditions laid out in the')}}
                          <a target="_blank" style="color: #D37700; text-decoration: underline" href="https://www.sherry.wine/es/privacy">{{ $t('Privacy Policy')}}</a>
                          <span class="required"> *</span>
                        </label>
        <div class="has-text-error-message" v-if="v$.termsAndConditions.$error">{{ $t('nec') }}{{ $t('nec') }}</div>
      </div>

      <div class="pt-5">
        <button style="background: #D37700; font-size: 14px; padding: 20px 40px;border: none"
                type="submit" class="button is-uppercase has-text-white has-text-weight-bold ">{{ $t('Send') }}
        </button>
      </div>

    </form>
  </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import {required, email, integer, url, helpers, requiredIf} from '@vuelidate/validators';
import VueUploadComponent from 'vue-upload-component';
import axios from "axios";

axios.defaults.xsrfCookieName = 'csrftoken';
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";

const phone = helpers.regex(/^\+34[0-9 ]{5,10}$/);
//const urlx = helpers.regex(/^http.*$/);

const time = helpers.regex(/^(0?[1-9]|1[012]):[0-5][0-9]$/);

import FileComponent from "./FileComponent.vue";

const hasddress = (value, siblings) => {
  console.log("siblings");
  console.log(siblings);
  return true && value;
};

const countries = require('i18n-iso-countries');
countries.registerLocale(require('i18n-iso-countries/langs/en.json'));

export default {

  setup() {
    return {v$: useVuelidate()};
  },
  name: 'Meetthemaker',
  components: {
    'file-upload': VueUploadComponent,
    'file-component': FileComponent,
  },
  props: {
    csrf: String,
    lang: String,
    waglocale: String
  },
  data() {
    return {
      success: false,

      files: [],
      files2: [],

      f1: null,
      f2: null,

      nec: "Este campo es necesario",
      mail: "Este campo tiene que ser un email",
      url: "Este campo tiene que ser un url",
      tel: "Este campo tiene que ser telefono",
      cpe: "Este campo tiene que un código postal",

      firstName: '',
      surName: '',
      bodega: '',
      city: '',
      professionTitle: '',
      instagram: '',
      twitter: '',
      howLong: '',
      whatMade: '',
      proudest: '',
      favouriteSherry: '',
      favouriteWine: '',
      mostInteresting: '',
      memories: '',
      plans: '',
      termsAndConditions: null
    };
  },
  validations() {
    function termsAgreed() {
      return this.termsAndConditions;
    }

    function atLeastOneVenue() {
      for (const item in this.venueTypes) {
        if (this.venueTypes[item])
          return true;
      }
      return false;
    }

    return {
      firstName: {required},
      surName: {required},
      bodega: {required},
      city: {required},
      professionTitle: {required},
      instagram: {url},
      twitter: {url},
      howLong: {required},
      whatMade: {required},
      proudest: {required},
      favouriteSherry: {required},
      favouriteWine: {required},
      mostInteresting: {required},
      memories: {required},
      plans: {required},
      termsAndConditions: {required, termsAgreed}
    };
  },
  methods: {
    doSuccess() {
      this.success = true;
      //this.scrollToClass('event')
      window.scrollTo(0, 0);
    },

    async submit() {
      const result = await this.v$.$validate();
      if (!result) {
        // notify user form is invalid
        this.scrollToClass('has-text-error-message');
        return;
      }

      const formData = {
        f1: this.f1,
        // f2: this.files2[0].response.id,

        firstName: this.firstName,
        surName: this.surName,
        bodega: this.bodega,
        city: this.city,
        professionTitle: this.professionTitle,
        instagram: this.instagram,
        twitter: this.twitter,
        howLong: this.howLong,
        whatMade: this.whatMade,
        proudest: this.proudest,
        favouriteSherry: this.favouriteSherry,
        favouriteWine: this.favouriteWine,
        mostInteresting: this.mostInteresting,
        memories: this.mostInteresting,
        plans: this.plans,
        waglocale: this.waglocale
      };

      axios.post("/api/meetthemaker/", formData)
          .then((res) => {
            console.log(res);
            this.doSuccess();
            // this.success = true;
          })
          .catch((err) => {
            alert("Ha habido un error, contacta con soporte");
          });

    },

    scrollToClass(className) {
      const el = this.$el.getElementsByClassName('has-text-error-message')[0];
      if (el) {
        el.scrollIntoView({behavior: "smooth", block: "center", inline: "start"});
      }
    },
    async inputFile(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file1.active) {
          this.$refs.file1.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },
    inputFile2(newFile, oldFile) {
      if (Boolean(newFile) !== Boolean(oldFile) || oldFile.error !== newFile.error) {
        if (!this.$refs.file2.active) {
          this.$refs.file2.active = true;
          //this.progress(newFile, oldFile)
        }
      }
    },

    inputFilter(newFile, oldFile, prevent) {

      if (newFile && !oldFile) {

        if (!newFile.name.match((/.png|.jpg|.gif$/))) {
          alert("El archivo tiene que ser png o jpg");
          return prevent();
        }
      }

      if (newFile.size > 1024 * 1024 * 4) {
        alert("El archivo tiene que tener menos de 4 MB");
        return prevent();
      }

      if (newFile && newFile.error === "" && newFile.file && (!oldFile || newFile.file !== oldFile.file)) {
        // Create a blob field
        newFile.blob = '';
        let URL = (window.URL || window.webkitURL);
        if (URL) {
          newFile.blob = URL.createObjectURL(newFile.file);
        }
        // Thumbnails
        newFile.thumb = '';
        if (newFile.blob && newFile.type.substr(0, 6) === 'image/') {
          newFile.thumb = newFile.blob;
        }
      }
    },
  },
  computed: {
    countries() {
      const list = countries.getNames('en', {select: 'official'});
      return Object.keys(list).map((key) => ({value: key, label: list[key]}));
    }
  },
  watch: {
    files: {
      handler: function (files, oldVal) {
        if (files.length > 0 && files[0].response && files[0].response.id) {
          this.f1 = files[0].response.id;
          return;
        }
        this.f1 = null;

      },
      deep: true
    },
    files2: {
      handler: function (files2, oldVal) {
        if (files2.length > 0 && files2[0].response && files2[0].response.id) {
          this.f2 = files2[0].response.id;
          return;
        }
        this.f2 = null;
      },
      deep: true
    }
  },
  mounted() {
    this.$i18n.locale = this.lang;
  },
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
h3 {
  margin: 40px 0 0;
}

ul {
  list-style-type: none;
  padding: 0;
}

li {
  display: inline-block;
  margin: 0 10px;
}

a {
  color: #42b983;
}

.is-checkradio[type=checkbox] + label::after, .is-checkradio[type=checkbox] + label:after {
  color: #292624;
  border-color: #292624;

}

.is-checkradio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before {
  background: #FBF5EF;

}


label.label {
  margin-top: 30px;
}

dio[type=checkbox] + label::before, .is-checkradio[type=checkbox] + label:before, .is-checkradio[type=radio] + label::before, .is-checkradio[type=radio] + label:before {
  border-color: #FBF5EF;
}

.is-checkradio[type=checkbox]:hover:not([disabled]) + label::before, .is-checkradio[type=checkbox]:hover:not([disabled]) + label:before, .is-checkradio[type=radio]:hover:not([disabled]) + label::before, .is-checkradio[type=radio]:hover:not([disabled]) + label:before {
  border-color: #d37700 !important;

}

.uploader {
  padding: 30px;
  background: #FBF5EF;
  border: 1px dashed #C3B193;
  border-radius: 10px;
  width: 100%;
  display: block;

}

.has-text-error-message {
  background: darkred;
  color: white !important;
  padding: 5px 10px;
  border-radius: 5px;
  font-weight: 600;
  margin-top: 3px;
  display: block;
}

.upload-photo {
  width: 90%;
  height: auto;
  display: block;

}

</style>